import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Utils from 'yoda-core-components/lib/helpers/Utils/Utils';
import YouTubePlayer from './YouTubePlayer';
import Scene7Player from './Scene7Player';
import VideoPlayerForiOS from './VideoPlayerForiOS';
import * as styles from './Scene7Player.css';

export const PROVIDER = {
    YOUTUBE: 'YOUTUBE',
    SCENE7: 'SCENE7',
    ADOBE: 'ADOBE',
};

class VideoPlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Player: props.provider === PROVIDER.YOUTUBE ? YouTubePlayer : Scene7Player,
        };
    }

    /* istanbul ignore next */
    componentDidMount() {
        const { deviceType, provider, width, height } = this.props;
        const posterWidth = parseInt(
            width || this.videoPlayerRef.getBoundingClientRect().width,
            10
        );
        const posterHeight = deviceType?.isTablet
            ? 'calc(50vw - 25px)'
            : parseInt(height || this.videoPlayerRef.getBoundingClientRect().height, 10);
        if (Utils.findMobileOS() === 'iOS' && provider !== PROVIDER.YOUTUBE) {
            this.setState({
                Player: VideoPlayerForiOS,
                posterWidth,
                posterHeight,
            });
        }
    }

    render() {
        const {
            playerProps: { url: videoId = '' } = {},
            playerId: index = 0,
            disableAutoPlay = false,
            videoTheme = '',
            isPDP,
        } = this.props;
        const { Player, posterHeight, posterWidth } = this.state;
        const playerProps = {
            index,
            videoId,
            disableAutoPlay,
            videoTheme,
            posterHeight,
            posterWidth,
            ...this.props,
        };
        return (
            <div
                className={styles.videoContainer}
                ref={(node) => {
                    this.videoPlayerRef = node;
                }}
            >
                <Player {...playerProps} />
            </div>
        );
    }
}

VideoPlayer.propTypes = {
    provider: PropTypes.oneOf([PROVIDER.YOUTUBE, PROVIDER.SCENE7, PROVIDER.ADOBE]).isRequired,
    playerProps: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    disableAutoPlay: PropTypes.bool.isRequired,
    videoTheme: PropTypes.string.isRequired,
    isResponsive: PropTypes.bool,
    deviceType: PropTypes.object,
    isPDP: PropTypes.bool,
    width: PropTypes.string,
    height: PropTypes.string,
};

VideoPlayer.defaultProps = {
    isResponsive: false,
    isPDP: false,
};

export default VideoPlayer;
